import { render } from "./AddClassByFile.vue?vue&type=template&id=67e6a0c2&scoped=true"
import script from "./AddClassByFile.vue?vue&type=script&lang=js"
export * from "./AddClassByFile.vue?vue&type=script&lang=js"

import "./AddClassByFile.vue?vue&type=style&index=0&id=67e6a0c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e6a0c2"]])

export default __exports__